import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpgradeOptionsGrid = ({ currentTier, onSelectPlan }) => {
  const plans = [
    {
      id: 'starter',
      name: 'Starter',
      price: 49,
      icon: 'Rocket',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20',
      popular: false,
      features: [
        '1 book per month',
        'Full AI agent access',
        'Skool community access',
        'Priority email support',
        'KDP formatting tools',
        'Basic cover design'
      ]
    },
    {
      id: 'professional',
      name: 'Professional',
      price: 99,
      icon: 'Crown',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/20',
      popular: true,
      features: [
        '4 books per month',
        'Advanced AI features',
        'Premium community access',
        'Priority support',
        'Professional cover design',
        'Marketing guidance',
        'SEO optimization',
        'Publishing consultation'
      ]
    },
    {
      id: 'enterprise',
      name: 'Enterprise',
      price: 999,
      icon: 'Building',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20',
      popular: false,
      features: [
        'Unlimited books',
        'White-glove service',
        'Dedicated account manager',
        '24/7 priority support',
        'Custom AI training',
        'Publishing consultation',
        'Marketing strategy',
        'Distribution assistance',
        'Revenue optimization'
      ]
    }
  ];

  const getTierIndex = (tier) => {
    const tiers = ['free', 'starter', 'professional', 'enterprise'];
    return tiers?.indexOf(tier);
  };

  const currentTierIndex = getTierIndex(currentTier);

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm p-6">
      <div className="mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">Upgrade Your Plan</h3>
        <p className="text-sm text-muted-foreground">
          Choose a plan that fits your book creation goals and unlock more features
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {plans?.map((plan, index) => {
          const planIndex = getTierIndex(plan?.id);
          const isCurrentPlan = plan?.id === currentTier;
          const isDowngrade = planIndex < currentTierIndex;
          const isUpgrade = planIndex > currentTierIndex;

          return (
            <div
              key={plan?.id}
              className={`relative border rounded-lg overflow-hidden transition-all duration-200 ${
                plan?.popular
                  ? 'border-secondary shadow-lg scale-105'
                  : isCurrentPlan
                  ? `${plan?.borderColor} bg-muted/20`
                  : 'border-border hover:border-primary/30'
              }`}
            >
              {plan?.popular && (
                <div className="absolute top-0 right-0 bg-secondary text-secondary-foreground px-3 py-1 text-xs font-medium rounded-bl-lg">
                  Most Popular
                </div>
              )}
              <div className={`p-6 ${plan?.bgColor}`}>
                <div className="flex items-center space-x-3 mb-4">
                  <div className={`w-10 h-10 rounded-lg ${plan?.bgColor} flex items-center justify-center`}>
                    <Icon name={plan?.icon} size={20} className={plan?.color} />
                  </div>
                  <h4 className="text-xl font-heading font-bold text-foreground">{plan?.name}</h4>
                </div>

                <div className="mb-6">
                  <span className="text-4xl font-heading font-bold text-foreground">${plan?.price}</span>
                  <span className="text-sm text-muted-foreground">/month</span>
                </div>

                <div className="space-y-3 mb-6">
                  {plan?.features?.map((feature, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-foreground">{feature}</span>
                    </div>
                  ))}
                </div>

                {isCurrentPlan ? (
                  <Button variant="outline" size="default" fullWidth disabled>
                    Current Plan
                  </Button>
                ) : isDowngrade ? (
                  <Button
                    variant="ghost"
                    size="default"
                    fullWidth
                    onClick={() => onSelectPlan(plan?.id)}
                  >
                    Downgrade
                  </Button>
                ) : (
                  <Button
                    variant={plan?.popular ? 'default' : 'outline'}
                    size="default"
                    fullWidth
                    iconName="ArrowRight"
                    iconPosition="right"
                    onClick={() => onSelectPlan(plan?.id)}
                  >
                    {isUpgrade ? 'Upgrade Now' : 'Select Plan'}
                  </Button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpgradeOptionsGrid;